import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';

const Editable = ({
  childRef,
  text,
  type,
  firstEdit,
  setShowTable,
  placeholder,
  children,
  ...props
}) => {
  const [isEditing, setEditing] = useState(firstEdit);
  const [isFirstEdit, setFirstEdit] = useState(firstEdit);

  const handleKeyDown = (event, type) => {
    if (event.keyCode === 13) setEditing(false);
  };

  const handleClick = () => {
    setEditing(false);
    setFirstEdit(false);
    setShowTable(true);
    console.log('continue clicked');
  };

  useEffect(() => {
    if (childRef && childRef.current && isEditing === true) {
      childRef.current.focus();
    }
  }, [isEditing, childRef]);

  return (
    <section {...props}>
      {isEditing ? (
        <div>
          {isFirstEdit ? (
            <div
              className="u--display-flex"
              onKeyDown={(e) => handleKeyDown(e, type)}
            >
              {children}
              {text ? (
                <button
                  className="btn btn--blue u--margin-left-10"
                  onClick={handleClick}
                >
                  <span className="btn__content">
                    <span className="btn__text">Continue</span>
                  </span>
                </button>
              ) : (
                <button
                  className="btn btn--blue u--margin-left-10"
                  style={{ opacity: '0.5' }}
                >
                  <span className="btn__content">
                    <span className="btn__text">Continue</span>
                  </span>
                </button>
              )}
            </div>
          ) : (
            <div
              className="u--display-flex"
              onBlur={() => setEditing(false)}
              onKeyDown={(e) => handleKeyDown(e, type)}
            >
              {children}
              <button className="btn btn--blue u--margin-left-10">
                <span className="btn__content">
                  <span className="btn__text">Update</span>
                </span>
              </button>
            </div>
          )}
        </div>
      ) : (
        <div onClick={() => setEditing(true)} className="u--display-flex">
          <span className="u--font-size-lg u--margin-right-5">
            {text || placeholder || 'Editable content'}
          </span>
          <FontAwesomeIcon
            icon={faPencilAlt}
            className="group-input__pencil-icon"
          />
        </div>
      )}
    </section>
  );
};

export default Editable;
